export const Prices = [
  {
    _id: 0,
    name: "Rs.0 - Rs.99",
    array: [0, 99],
  },
  {
    _id: 1,
    name: "Rs.100 - Rs.999",
    array: [100, 999],
  },
  {
    _id: 2,
    name: "Rs.1000 - Rs.4999",
    array: [1000, 4999],
  },
  {
    _id: 3,
    name: "Rs.5000 - Rs.19999",
    array: [5000, 19999],
  },
  {
    _id: 4,
    name: "Rs.20000 and above",
    array: [20000, 99999999],
  },
];
